import React, { Component } from 'react';

class AddressList extends Component {
    render() {
        const { addressList = [], onEditAddress }  = this.props ;
        return (
            <div className="ps-address-list">
                    {addressList.length>0 ?
                        addressList.map((data)=>{
                            return(
                                <article className="ps-address-list__item" key={data.address_id}>
                                    <div className="ps-address-list__itemHeader">
                                        <div className="ps-address-list__meta">
                                            <strong>{data.user_name}</strong>
                                            <span>{data.user_mobile}</span>
                                        </div>
                                        <div className="ps-address-list__actions">
                                            <span className="ps-address-list__type">{(data.user_address_type=='W')? 'Work' : 'Home'}</span>
                                            <button
                                                type="button"
                                                className="ps-address-list__editButton"
                                                onClick={() => onEditAddress && onEditAddress(data)}
                                            >
                                                <i className="fa fa-pencil"></i>
                                                <span>Edit</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="ps-address-list__body">
                                        <p>{data.user_address}, {data.user_locality}, {data.user_city}</p>
                                        <p>{data.user_state}, {data.user_landmark}, {data.user_pincode}</p>
                                    </div>
                                </article>
                            );
                        })
                    :
                        <p className="ps-address-list__empty">No address found</p>
                    }
            </div>
        );
    }
}

export default AddressList;
